import { requests } from '../../../utils';
import { PACKAGES_URL } from '../../../utils/endpoints';
import { BaseModel } from '../../../model/shared/BaseModel';
import { IPackages } from '../../../model/shared/IPackages';

export const PackagesService = {
    getPackages: (): Promise<BaseModel<IPackages[]>> => requests.get(`${PACKAGES_URL}`),
};
